let $theme_child = powergut_theme_child;

jQuery(document).ready(function() {
    initLabelMiniCart();
    initWoocommerceListView();
    addArrowFilterTitle();
    initPopupFilterBy();
    checkIfFilters();
    addClassHoverCardProductClickable();
    //addBtnPlusMinusQuantity();

    if(jQuery('.pgut-pc-mega-menu').length > 0){
        loadBlockMegaMenu();
    }

    // Bouton flottant "Ajouter au panier", simuler le clic sur le bouton submit non flottant
    if(jQuery('.pgut-product__add-to-cart a').length > 0){
        jQuery('.pgut-product__add-to-cart a').click(function(){
            jQuery('form.cart button[type="submit"]').trigger('click');
        });
    }

    if(jQuery('#pgut-topbar').length > 0){
        // Disparition de la topbar
        hideHeaderTopBar();
    }

    /* Au scroll, montrer ou cacher header topbar */
    jQuery(window).scroll(function(){
        if(jQuery('#pgut-topbar').length > 0) {
            if (jQuery(document).scrollTop() > 200) {
                jQuery('#pgut-topbar').hide();
            } else if (jQuery(document).scrollTop() == 0) {
                if (jQuery('#pgut-topbar').is(":hidden")) {
                    jQuery('#pgut-topbar').show();
                }
            }
        }
    });

    jQuery(document).on('change', '.pgut-variation-radios input', function(){
        changeDropdownProductVariations();
    });
});

function initLabelMiniCart(){
    jQuery('.pgut-icon-menu .pgut-mini-cart').mousedown( function(e){
        e.preventDefault();
        jQuery('.wc-block-mini-cart__button').trigger('click');
    });
}

function initWoocommerceListView(){
    if(jQuery('.pgut-woocommerce-listing').length > 0){
        var cookieNRWoocommerceListingValue = document.cookie.replace(/(?:(?:^|.*;\s*)pgut_woocommerce_listing\s*\=\s*([^;]*).*$)|^.*$/, "$1");

        if(cookieNRWoocommerceListingValue){
            changeWoocommerceListView()
        }

        jQuery('.pgut-woocommerce-listing').on('click', function(){
            jQuery('.pgut-woocommerce-listing').removeClass('active');
            jQuery(this).addClass('active');
            var style_list = jQuery(this).attr('data-style');
            document.cookie = 'pgut_woocommerce_listing='+style_list+';';
            changeWoocommerceListView();
        });
    }
}

function changeWoocommerceListView(){
    if(jQuery('.pgut-woocommerce-listing').length > 0){
        var cookieNRWoocommerceListingValue = document.cookie.replace(/(?:(?:^|.*;\s*)pgut_woocommerce_listing\s*\=\s*([^;]*).*$)|^.*$/, "$1");

        if(cookieNRWoocommerceListingValue){
            jQuery('.wp-block-woocommerce-product-template .product').each(function(){
                jQuery(this).removeClass('grid list').addClass(cookieNRWoocommerceListingValue);
            });

            jQuery('.pgut-woocommerce-style-listing .pgut-woocommerce-listing').each(function(){
                jQuery(this).removeClass('active');
                jQuery('.pgut-shop-results').removeClass('grid list').addClass(cookieNRWoocommerceListingValue);

                if(jQuery(this).hasClass('pgut-woocommerce-listing__'+cookieNRWoocommerceListingValue)){
                    jQuery(this).addClass('active');
                }
            });
        }
    }
}

function changeDropdownProductVariations(){
    jQuery( '.pgut-variation-radios input:checked' ).each( function( index, element ) {
        const radio = jQuery(element);
        const radioName = radio.attr( 'name' )
        const radioValue  = radio.attr( 'value' )
        jQuery( 'select[name="' + radioName + '"]' ).val( radioValue ).trigger( 'change' );
    })
}

function addArrowFilterTitle(){
    if(jQuery('.archive.tax-product_cat .pgut-shop-sidebar .wc-blocks-filter-wrapper .wp-block-heading').length > 0){
        jQuery('.archive.tax-product_cat .pgut-shop-sidebar .wc-blocks-filter-wrapper .wp-block-heading').each(function(index,element){
            jQuery('<img src="/wp-content/themes/'+$theme_child["theme_slug"]+'/build/svg/icons-woocommerce/arrow-accordion-top.svg" alt="" />').appendTo(element);

            jQuery('.pgut-sidebar-shop > div:first-child .wc-blocks-filter-wrapper').addClass('active');
            jQuery('.pgut-sidebar-shop-technical-features > div:first-child .wc-blocks-filter-wrapper').addClass('active');

            jQuery(this).click( function(){
                jQuery(this).parent().toggleClass('active');
            })
        });
    }
}

function initPopupFilterBy(){
    if(jQuery('body .pgut-shop-sidebar').length > 0){
        jQuery('.pgut-shop-sidebar .pgut-open-popup').click(function(){
            jQuery('.pgut-shop-sidebar .pgut-sidebars').addClass('open');
        });

        jQuery('.pgut-shop-sidebar .pgut-close-popup').click(function(){
            jQuery('.pgut-shop-sidebar .pgut-sidebars').removeClass('open');
        });
    }
}

/* Increase or decrease input number quantity thanks to span minus and plus */
function addBtnPlusMinusQuantity(){
    if(jQuery('.woocommerce input.qty:not([type=hidden])').length > 0){
        jQuery('.woocommerce input.qty:not([type=hidden])').each(function(){
            jQuery(this).before('<span class="pgut-btn-minus"><img src="/wp-content/themes/'+$theme_child["theme_slug"]+'/assets/svg/icons-woocommerce/minus.svg" alt="Icône moins" /></span>');
            jQuery(this).after('<span class="pgut-btn-plus"><img src="/wp-content/themes/'+$theme_child["theme_slug"]+'/assets/svg/icons-woocommerce/plus.svg" alt="Icône plus" /></span>');

            jQuery('.pgut-btn-minus').click(function(){
                jQuery(this).next('.qty').val(Math.max(parseInt(jQuery(this).next('.qty').val())-1, 0));
            });

            jQuery('.pgut-btn-plus').click(function(){
                jQuery(this).prev('.qty').val(parseInt(jQuery(this).prev('.qty').val())+1);
            });
        });
    }
}

/* Cache la topbar du header */
function hideHeaderTopBar(){
    jQuery('#pgut-topbar .pgut-img-cross img').click( function(){
        jQuery('#pgut-topbar').remove();
    });
}

// Actions et événements liés au bloc mega menu
function loadBlockMegaMenu(){
    // Fonction pour vérifier si l'appareil est non mobile
    function isNonMobileDevice(){
        // Vérifier si l'appareil supporte le hover (media query moderne)
        if(window.matchMedia && window.matchMedia('(hover: hover)').matches){
            return true;
        }
        // Fallback : vérifier la largeur de l'écran (>= 768px généralement considéré comme tablette/desktop)
        return jQuery(window).width() >= 768;
    }

    // Hover sur le menu burger - Ici pour le custom pour ouvrir le megamenu
    // Ne s'applique qu'aux appareils non mobiles
    if(isNonMobileDevice()){
        jQuery('.pgut-pc-mega-menu.pgut-pc-mega-menu__custom-item-parent .pgut-pc-mega-menu__icons-menu:not(.open)').mouseenter(function(e){
            //.pgut-pc-mega-menu
            jQuery(this).parent().addClass('open');
            jQuery('#pgut-header__menu').parent().addClass('pgut-header__content__dark-background');

            // Si le menu des catégories parentes et enfants ne contiennent pas la classe open
            // Alors on ajoute la classe open au menu des catégories parentes
            var $element = jQuery(this);
            toggleParentCategoryMegaMenu($element);
        });

        // Hover sur le menu burger - Ici pour le custom pour fermer le megamenu
        // Ne s'applique qu'aux appareils non mobiles
        jQuery('.pgut-pc-mega-menu.pgut-pc-mega-menu__custom-item-parent').mouseleave(function(){
            //.pgut-pc-mega-menu
            jQuery(this).removeClass('open');
            jQuery('#pgut-header__menu').parent().removeClass('pgut-header__content__dark-background');

            // Si le menu des catégories parentes et enfants ne contiennent pas la classe open
            // Alors on ajoute la classe open au menu des catégories parentes
            var $element = jQuery(this).find('.pgut-pc-mega-menu__icons-menu');
            toggleParentCategoryMegaMenu($element);
        });
    }

    // Clic sur le menu burger
    jQuery('.pgut-pc-mega-menu .pgut-pc-mega-menu__icons-menu img').click(function(){
        //.pgut-pc-mega-menu
        jQuery(this).closest('.pgut-pc-mega-menu__icons-menu').parent().toggleClass('open');
        jQuery('#pgut-header__menu').closest('.pgut-pc-mega-menu__icons-menu').parent().toggleClass('pgut-header__content__dark-background');

        // Si le menu des catégories parentes et enfants ne contiennent pas la classe open
        // Alors on ajoute la classe open au menu des catégories parentes
        var $element = jQuery(this).closest('.pgut-pc-mega-menu__icons-menu');
        toggleParentCategoryMegaMenu($element);

    });

    // Clic sur le bouton "Fermer"
    jQuery('.pgut-pc-mega-menu .pgut-pc-mega-menu__top-menu img:nth-of-type(2)').click(function(){
        jQuery(this).parents('.pgut-pc-mega-menu').removeClass('open');
        jQuery('#pgut-logo-search').parent().removeClass('pgut-header__content__dark-background');
    });

    // Clic sur le bouton "Suite" d'une catégorie pour voir les sous-catégories
    jQuery('.pgut-pc-mega-menu .pgut-pc-mega-menu__parent-product-category.pgut-pc-mega-menu__parent-has-child').click(function(){
        var id_parent_category = jQuery(this).attr('data-id');
        var block_mega_menu = jQuery(this).parents('.pgut-pc-mega-menu');

        // Sur le bouton "Retour en arrière", on ajoute l'id de la catégorie parente
        // + on l'affiche
        block_mega_menu.find('.pgut-pc-mega-menu__top-menu').attr('data-id', id_parent_category).addClass('show');

        // Afficher le menu des catégories enfants
        block_mega_menu.find('.pgut-pc-mega-menu__child-product-categories[data-id="'+id_parent_category+'"]').parent().addClass('open');

        // Afficher le bon sous-menu des catégories enfant en fonction de la catégorie parent choisie
        block_mega_menu.find('.pgut-pc-mega-menu__child-product-categories[data-id="'+id_parent_category+'"]').addClass('open');
        // Cacher tous les voisins de même niveau
        block_mega_menu.find('.pgut-pc-mega-menu__child-product-categories[data-id="'+id_parent_category+'"]').siblings().removeClass('open');
        block_mega_menu.find('.pgut-pc-mega-menu__child-product-categories[data-id="'+id_parent_category+'"]').parent().next().removeClass('open');
        block_mega_menu.find('.pgut-pc-mega-menu__child-product-categories[data-id="'+id_parent_category+'"]').parent().next().children().removeClass('open');
    });

    // Clic sur le bouton "Retour en arrière"
    jQuery('.pgut-pc-mega-menu .pgut-pc-mega-menu__top-menu img:first-child').click(function(){
        // Si le bouton a bien l'attribut data-id
        if(jQuery(this).parent().attr('data-id') != null){
            var id_back = jQuery(this).parent().attr('data-id');
            var menu_content = jQuery(this).parents('.pgut-pc-mega-menu__menu-content');

            // Afficher le menu des catégories parentes
            menu_content.find('.pgut-pc-mega-menu__child-product-categories[data-id="'+id_back+'"]').toggleClass('open');
            menu_content.find('.pgut-pc-mega-menu__child-product-categories[data-id="'+id_back+'"]').parent().toggleClass('open');

            // Trouver l'id de la catégorie parente pour pouvoir refaire le "Retour arrière"
            var new_id_back = jQuery(".pgut-pc-mega-menu__children-product-categories.open .open").last().attr("data-id");
            if(new_id_back){
                jQuery(this).parent().attr('data-id', new_id_back);
            }
            else {
                // S'il n'y a pas d'id c'est qu'on est le sur le premier niveau dnc on enlève le bouton "Retour arrière"
                // Cacher l'icône "Retour en arrière"
                jQuery(this).parent().removeAttr('data-id').removeClass('show');
            }
        }
    });
}

// Si le menu des catégories parentes et enfants ne contiennent pas la classe open
// Alors on ajoute la classe open au menu des catégories parentes
function toggleParentCategoryMegaMenu($element){
    if(!$element.parents('.pgut-pc-mega-menu').find('.pgut-pc-mega-menu__children-product-categories').hasClass('open') && !$element.parents('.pgut-pc-mega-menu').find('.pgut-pc-mega-menu__parent-product-categories').hasClass('open')){
        $element.parents('.pgut-pc-mega-menu').find('.pgut-pc-mega-menu__parent-product-categories').toggleClass('open');
    }
}

function checkIfFilters(){
    setTimeout(function(){
        if(jQuery('.archive.search.search-results.post-type-archive-product .pgut-shop-content #yith-filters-panel').length == 0){
            jQuery('.archive.search.search-results.post-type-archive-product .pgut-shop-content').addClass('pgut-no-filters');
        }
    }, 200);
}

function addClassHoverCardProductClickable(){
    if(jQuery('.pgut-product-clickable').length > 0){
        // mouseup plutôt que click pour le clic roulette
        jQuery('.pgut-product-clickable').mouseup(function(e){
            // Ne pas court-circuiter les liens/boutons internes (ajout panier, wishlist, voir le produit…)
            if(jQuery(e.target).closest('a, button').length){
                return;
            }
            e.preventDefault();
            if(e.which == 1){
                // Pour ouvrir dans un nouvel onglet
                if(jQuery(this).find('a:not(.yith-wcwl-add-to-wishlist-button)').eq(0).attr("target") == "_blank" ){
                    window.open(jQuery(this).find('a').eq(0).attr("href"));
                }
                else {
                    window.location.href = jQuery(this).find('a:not(.yith-wcwl-add-to-wishlist-button)').eq(0).attr("href");
                }
            }
            else if(e.which == 2){
                window.open(jQuery(this).find('a').eq(0).attr("href"));
            }

            e.stopPropagation();
        });
    }
}